module.exports = __webpack_public_path__ + "media/images/recruit/top/mv_stone_grn-320df0b5f842cf45c32a6b84192efb1e.png";